import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from './LocalStorageHelper'

const USER_ID_KEY = 'echow-userID-v1'
const USER_ANONYMOUS_ID_KEY = 'echow-random-userID-v1'
const GLEAP_TOUR_ALREADY_SHOWN = 'echow-gleap-tour-already-shown'

const getUserID = () => getLocalStorageItem<number>(USER_ID_KEY)
const setUserID = (id: number) => setLocalStorageItem<number>(USER_ID_KEY, id)
const removeUserID = () => removeLocalStorageItem(USER_ID_KEY)

const getUserAnonymousID = (): string => {
  const storedValue = getLocalStorageItem<string>(USER_ANONYMOUS_ID_KEY)
  if (storedValue) {
    return storedValue.toString()
  }
  const random = crypto.randomUUID()
  setLocalStorageItem<string>(USER_ANONYMOUS_ID_KEY, random)
  return random
}
const removeUserAnonymousID = () =>
  removeLocalStorageItem(USER_ANONYMOUS_ID_KEY)

const getGleapTourAlreadyShown = () =>
  getLocalStorageItem<string | undefined>(GLEAP_TOUR_ALREADY_SHOWN)
const setGleapTourAlreadyShown = (tourId: string) =>
  setLocalStorageItem<string | undefined>(GLEAP_TOUR_ALREADY_SHOWN, tourId)
const removeGleapStorage = () => {
  removeLocalStorageItem(GLEAP_TOUR_ALREADY_SHOWN)
}

export {
  getUserID,
  setUserID,
  removeUserID,
  getUserAnonymousID,
  removeUserAnonymousID,
  getGleapTourAlreadyShown,
  setGleapTourAlreadyShown,
  removeGleapStorage,
}
